module.exports = __webpack_public_path__ + "media/images/authentication/reset_password_edit-1a16acee3d5b6028bbfd79a2ee42c26d.png";